import { render, staticRenderFns } from "./PermissionDialog.vue?vue&type=template&id=3f4de6b2"
import script from "./PermissionDialog.vue?vue&type=script&lang=js"
export * from "./PermissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4de6b2')) {
      api.createRecord('3f4de6b2', component.options)
    } else {
      api.reload('3f4de6b2', component.options)
    }
    module.hot.accept("./PermissionDialog.vue?vue&type=template&id=3f4de6b2", function () {
      api.rerender('3f4de6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PermissionDialog.vue"
export default component.exports